import AboutMe from "./AboutMe";
import Contact from "./Contact";
import Header from "./Header";
import Main from "./Main";
import Works from "./Works";
function Home() {
  return (
    <>
      <Header />
      <Main />
      <AboutMe />
      <Works />
      <Contact />
    </>
  )
}

export default Home